"use client";

import { useState, useEffect } from "react";
import { Box, styled } from "@mui/material";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

const Root = styled(Box)({
  height: "var(--space-10, 40px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  boxSizing: "border-box",
  backgroundColor: "var(--bg-subtle)",
});

export default function Copyright(props) {
  const { sx, ...typographyProps } = props;
  // Use a static year initially to avoid hydration mismatch, then update on client
  const [year, setYear] = useState(2025);

  useEffect(() => {
    // Intentional: client-only value updated after mount to avoid an SSR
    // hydration mismatch on the year.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setYear(new Date().getFullYear());
  }, []);

  return (
    <Root>
      <Typography
        variant="body2"
        color="text.secondary"
        align="center"
        sx={{
          ...sx,
          font: "var(--text-label)",
          padding: 0,
          textTransform: "uppercase",
          letterSpacing: "1px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "var(--space-2, 8px)",
          height: "100%",
        }}
        {...typographyProps}
      >
        <Box
          component="span"
          aria-hidden="true"
          sx={{
            width: 17,
            height: 16,
            flexShrink: 0,
            backgroundColor: "currentColor",
            mask: "url(/img/floats/floats-logo-blue.svg) center / contain no-repeat",
            WebkitMask: "url(/img/floats/floats-logo-blue.svg) center / contain no-repeat",
          }}
        />
        <Box component="span" sx={{ lineHeight: "inherit" }}>
          {"Copyright © "}
          <span suppressHydrationWarning>{year}</span>{" "}
          <Link color="inherit" href="https://floats.ai/" sx={{ lineHeight: "inherit" }}>
            floats.ai
          </Link>
        </Box>
      </Typography>
    </Root>
  );
}
